import { render, staticRenderFns } from "./addFixingData.vue?vue&type=template&id=e338f3f8&"
import script from "./addFixingData.vue?vue&type=script&lang=js&"
export * from "./addFixingData.vue?vue&type=script&lang=js&"
import style0 from "./addFixingData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports